import CallCard from "./CallCard";
import { Call, RecordVoiceOver } from "@mui/icons-material";
import NoDataScreen from "../ui/temp-screens/NoDataScreen";
import { useState, useEffect, useRef } from "react";
import { useTwilioPhone } from "../../hooks/useTwilioPhone";
import { useSelector, useDispatch } from "react-redux";
import { resetCallEnded, close } from "../../features/twilioPhoneSlice";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import LoadingScreen from "../ui/temp-screens/LoadingScreen";
import DinamicButton from "../ui/components/DinamicButton";
import Modal from "../ui/Modal";
import { toast } from "react-toastify";
import { FormControl, InputLabel, ListItemText, OutlinedInput, Select, Checkbox, CircularProgress, MenuItem } from "@mui/material";
import { FaMicrophone, FaStop, FaPlay, FaPause, FaTrash, FaUpload, FaTimes, FaQuestionCircle, FaBoxOpen, FaFileInvoiceDollar, FaPhone, FaFileAudio } from "react-icons/fa";
import InputFormValue from "../ui/components/InputFormValue";
import callReasons from "../../utils/plainValues/CallReasons";
import { FaNoteSticky } from "react-icons/fa6";
import { Upload } from "@mui/icons-material";
import { CalculateUserCategory } from "../../utils/helpers/CalculateUserCategory";
import ModalInDrawer from "../ui/ModalInDrawer";

const CallSection = ({ quoteId, calls, refetch = null, clientData }) => {

  const user = useSelector((state) => state.auth.user);

  const { openWithClientAndQuote } = useTwilioPhone();
  const { client, quoteId: twilioQuoteId, callEnded } = useSelector((state) => state.twilioPhone);
  const dispatch = useDispatch();

  const [services, setServices] = useState([]);

  // Estados para grabación de audio
  const [manualCallModal, setManualCallModal] = useState(false);
  const [uploadingStatus, setUploadingStatus] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioPlayer, setAudioPlayer] = useState(null);
  const [uploadedAudioFile, setUploadedAudioFile] = useState(null);
  const [uploadedAudioUrl, setUploadedAudioUrl] = useState(null);
  const fileInputRef = useRef(null);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [processingCall, setProcessingCall] = useState(false);
  const [selectedServiceIds, setSelectedServiceIds] = useState([]);
  
  // Estados para el formulario
  const [newRegisterForm, setNewRegisterForm] = useState({
    worker: user.id,
    numberCalled: clientData?.telefono || clientData?.telefonoGerente || "",
    date: new Date().toISOString().split('T')[0],
    category: "Operativa",
    client: clientData?.id || "",
    servicesOfInterest: "",
    notes: "",
    quotesInput: "",
    quotes: [],
    reason: "",
    duration: 0,
  });

  // Estados para búsqueda
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(30);
  const [brandName, setBrandName] = useState("");
  const [workers, setWorkers] = useState([]);

  useEffect(() => {
    getServices();
  }, []);

  // Escuchar cuando termine una llamada
  useEffect(() => { 
    if (callEnded && client && twilioQuoteId) {
      console.log("Llamada terminada, refetching");

      dispatch(resetCallEnded());
      dispatch(close());

      setProcessingCall(true);

      setTimeout(() => {
        refetch();
        setProcessingCall(false);
      }, 5000);

    }
  }, [callEnded, client, twilioQuoteId, dispatch]);

  // Funciones para manejar servicios con IDs
  const handleServicesChange = (event) => {
    const selectedIds = event.target.value;
    
    // Actualizar el estado de IDs seleccionados
    setSelectedServiceIds(selectedIds);
    
    // Obtener los nombres de servicios que coinciden con los IDs seleccionados
    const selectedServiceNames = services
      .filter(service => selectedIds.includes(service.id))
      .map(service => service.name);
    
    // Actualizar el formulario con los nombres de servicios
    const servicesString = selectedServiceNames.join(', ');
    
    setNewRegisterForm(prev => ({ ...prev, servicesOfInterest: servicesString }));
  };

  // Función para verificar si un servicio está seleccionado
  const isServiceSelected = (serviceId) => {
    return selectedServiceIds.includes(serviceId);
  };

  // Funciones para grabación de audio
  const startRecording = async () => {
    // Verificar si ya hay un archivo subido
    if (uploadedAudioFile) {
      toast.error('Ya tienes un archivo de audio subido. Elimínalo primero para poder grabar.');
      return;
    }

    // Verificar si ya hay un audio grabado
    if (audioBlob) {
      toast.error('Ya tienes un audio grabado. Elimínalo primero para poder grabar uno nuevo.');
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const audioChunks = [];

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunks.push(event.data);
        }
      };

      recorder.onstop = () => {
        const blob = new Blob(audioChunks, { type: 'audio/wav' });
        const audioFile = new File([blob], "audio.wav", { type: 'audio/wav' });
        const url = URL.createObjectURL(blob);
        setAudioBlob(audioFile);
        setAudioUrl(url);
        setNewRegisterForm(prev => ({ ...prev, url: "" }));
        
        // Detener el stream para liberar el micrófono
        stream.getTracks().forEach(track => track.stop());
      };

      setMediaRecorder(recorder);
      recorder.start();
      setIsRecording(true);
      setRecordingTime(0);

      // Timer para mostrar el tiempo de grabación
      const timer = setInterval(() => {
        setRecordingTime(prev => prev + 1);
      }, 1000);

      recorder.addEventListener('stop', () => {
        clearInterval(timer);
      });

    } catch (error) {
      console.error('Error accessing microphone:', error);
      toast.error('Error al acceder al micrófono');
    }
  };

  const stopRecording = () => {
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  const playAudio = () => {
    const audioUrlToPlay = audioUrl || uploadedAudioUrl;
    if (audioUrlToPlay) {
      const audio = new Audio(audioUrlToPlay);
      audio.play();
      setIsPlaying(true);
      setAudioPlayer(audio);

      audio.onended = () => {
        setIsPlaying(false);
        setAudioPlayer(null);
      };
    }
  };

  const pauseAudio = () => {
    if (audioPlayer) {
      audioPlayer.pause();
      setIsPlaying(false);
      setAudioPlayer(null);
    }
  };

  const clearAudio = () => {
    // Detener grabación si está activa
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop();
    }
    
    // Detener reproducción si está activa
    if (audioPlayer) {
      audioPlayer.pause();
    }
    
    // Limpiar URL del audio grabado
    if (audioUrl) {
      URL.revokeObjectURL(audioUrl);
    }
    
    // Limpiar URL del archivo subido
    if (uploadedAudioUrl) {
      URL.revokeObjectURL(uploadedAudioUrl);
    }
    
         // Resetear todos los estados de audio
     setAudioBlob(null);
     setAudioUrl(null);
     setUploadedAudioFile(null);
     setUploadedAudioUrl(null);
     setIsPlaying(false);
     setAudioPlayer(null);
     setRecordingTime(0);
     setIsRecording(false);
     setMediaRecorder(null);
     setNewRegisterForm(prev => ({ ...prev, url: "" }));
    
    // Limpiar el input de archivo
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Funciones para manejar motivos de llamada
  const handleReasonsChange = (event) => {
    const selectedValues = event.target.value;
    
    // Actualizar el estado de motivos seleccionados
    setSelectedReasons(selectedValues);
    
    // Actualizar el formulario con los motivos como string separado por comas
    const reasonsString = selectedValues.join(', ');
    
    setNewRegisterForm(prev => ({ ...prev, reason: reasonsString }));
  };

  // Función para verificar si un motivo está seleccionado
  const isReasonSelected = (reasonValue) => {
    return selectedReasons.includes(reasonValue);
  };

  // Función para manejar la subida de archivos de audio
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Verificar si se está grabando
    if (isRecording) {
      toast.error('No puedes subir un archivo mientras estás grabando. Detén la grabación primero.');
      return;
    }

    // Validar que sea un archivo de audio
    if (!file.type.startsWith('audio/')) {
      toast.error('Por favor selecciona un archivo de audio válido');
      return;
    }

    // Validar tamaño del archivo (máximo 50MB)
    const maxSize = 50 * 1024 * 1024; // 50MB
    if (file.size > maxSize) {
      toast.error('El archivo es demasiado grande. Máximo 50MB');
      return;
    }

    // Limpiar audio grabado si existe
    if (audioBlob) {
      clearAudio();
    }

    // Crear URL para previsualización
    const url = URL.createObjectURL(file);
    setUploadedAudioFile(file);
    setUploadedAudioUrl(url);
         setNewRegisterForm(prev => ({ ...prev, url: "" }));
  };

  // Función para limpiar solo el archivo subido
  const clearUploadedFile = () => {
    if (uploadedAudioUrl) {
      URL.revokeObjectURL(uploadedAudioUrl);
    }
    setUploadedAudioFile(null);
    setUploadedAudioUrl(null);
         setNewRegisterForm(prev => ({ ...prev, url: "" }));
    
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Función para verificar si hay algún audio (grabado o subido)
  const hasAnyAudio = () => {
    return audioBlob || uploadedAudioFile;
  };

  // Función para formatear el tamaño del archivo
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const uploadAudio = async () => {
    // Verificar si hay algún audio (grabado o subido)
    const audioToUpload = audioBlob || uploadedAudioFile;
    if (!audioToUpload) return null;
    try {
      const formData = new FormData();
      const file = audioToUpload instanceof File 
        ? audioToUpload 
        : new File([audioToUpload], 'audio.wav', { type: 'audio/wav' });
      formData.append("file", file);

      // Subir el audio
      const response = await axios.post(`${BACKEND}/api/audiosLlamadasManuales`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      // Retornar la URL del audio subido
      return (response?.data?.doc?.url) || (response?.data?.url);
    } catch (error) {
      console.log(error);
      toast.error('Error al subir el audio');
      return null;
    }
  };

  const resetForm = () => {
    setSelectedReasons([])
    setSelectedServiceIds([])
    setNewRegisterForm({
      worker: user.id,
      numberCalled: clientData?.telefono || clientData?.telefonoGerente || "",
      date: new Date().toISOString().split('T')[0],
      category: "Operativa",
      client: clientData?.id || "",
      servicesOfInterest: "",
      notes: "",
      quotesInput: "",
      quotes: [],
      reason: "",
      duration: 0,
    });
  };

  const handleSubmit = async () => {
    try {
      // Validaciones
      if (!newRegisterForm.numberCalled) {
        toast.error('Debes ingresar el número de llamada');
        return;
      }

      if (!newRegisterForm.reason) {
        toast.error('Debes seleccionar el motivo de la llamada');
        return;
      }

      setUploadingStatus(true)

      // Si hay audio (grabado o subido), subirlo primero
      let audioUrl = null;
      if (hasAnyAudio()) {
        audioUrl = await uploadAudio();
        if (!audioUrl) {
          console.log("No hay audio xde")
          toast.error('Error al subir el audio');
          return;
        }
      }

      // Calcular duración si hay audio grabado
      const duration = audioBlob ? recordingTime : 0;

      // Preparar datos del formulario
      const formData = {
        ...newRegisterForm,
        worker: newRegisterForm.worker,
        numberCalled: newRegisterForm.numberCalled,
        date: newRegisterForm.date,
        category: CalculateUserCategory(user),
        reason: newRegisterForm.reason,
        client: newRegisterForm.client,
        servicesOfInterest: newRegisterForm.servicesOfInterest,
        notes: newRegisterForm.notes,
        quotes: [quoteId, ...(newRegisterForm.quotes || [])],
        url: audioUrl, // URL del audio subido
        duration: duration, // Duración en segundos,
        confirmedData: true
      };

      // Enviar el formulario
      await axios.post(`${BACKEND}/api/registroLlamadas`, formData);

      toast.success('Registro guardado exitosamente');
      setManualCallModal(false);
      resetForm();
      clearAudio(); // Asegurar que el audio se limpie completamente
      if (refetch) refetch(); // Actualizar la lista

    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Error al guardar el registro');
    } finally {
      setUploadingStatus(false)
    }
  };

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0`)
      setWorkers(response.data.docs)
    } catch (error) {
      return null
    }
  }

  const getServices = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`)
      setServices(response.data.docs)
    } catch (error) {
      return null
    }
  }

  const processQuotesInput = (inputValue) => {
    // Procesar el input y extraer IDs válidos
    const quotesArray = inputValue
      .split(',')
      .map(id => id.trim())
      .filter(id => {
        // Filtrar solo IDs válidos: exactamente 24 caracteres hexadecimales
        return id.length === 24 && /^[a-fA-F0-9]{24}$/.test(id);
      });
    
    // Actualizar el array de quotes válidos
    setNewRegisterForm(prev => ({ ...prev, quotes: quotesArray }));
  };

  useEffect(() => {
    // getRecord() // Comentado porque no tienes esta función
  }, [page, limit])

  useEffect(() => {
    // getRecord() // Comentado porque no tienes esta función
    getWorkers()
    getServices()
  }, [])

  useEffect(() => { 
    if (brandName === "") {
      // getRecord(); // Comentado porque no tienes esta función
      setPage(1); 
    }
  }, [brandName]);

  // Limpiar audio cuando se abre el modal
  useEffect(() => {
    if (manualCallModal) {
      clearAudio();
    }
  }, [manualCallModal]);


  return (
    <div className="flex flex-col gap-4 mb-4">

      {/* Modal para grabación manual */}
      <ModalInDrawer
        activeModal={manualCallModal}
        onClose={() => {
          setManualCallModal(false)
          clearAudio()
        }}
        title="Registrar llamada manual"
        centered
        className="max-w-3xl"
      >
        <div className="flex flex-col h-[70vh]">
          
          {/* Contenido scrolleable */}
          <div className="flex-1 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            <div className="flex flex-col gap-4">

              {/* Información del cliente y cotización */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="font-semibold text-blue-800 text-xs mb-2">Información de la llamada:</h3>
                <div className="text-xs text-blue-700">
                  <div><strong>Cliente:</strong> {clientData?.nombreComercial || 'N/A'}</div>
                  <div><strong>Cotización:</strong> {quoteId}</div>
                  <div><strong>Trabajador:</strong> {user?.name || 'N/A'}</div>
                </div>
              </div>

              {/* Formulario */}
              <div className="flex flex-col gap-4">
                
                {/* Número de llamada */}
                <InputFormValue
                  title="Número de llamada"
                  info="Número al que se llamó"
                  value={newRegisterForm.numberCalled}
                  setValue={(value) => setNewRegisterForm(prev => ({ ...prev, numberCalled: value }))}
                  icon={<FaPhone />}
                  placeholder="Número al que se llamó"
                  type="text"
                />

                {/* Cotizaciones vinculadas */}
                <div>
                  <InputFormValue
                    title="Cotizaciones vinculadas"
                    info="IDs de cotizaciones (ObjectId de 24 caracteres) separados por comas"
                    value={newRegisterForm.quotesInput}
                    setValue={(value) => {
                      // Actualizar el campo de input sin filtrar
                      setNewRegisterForm(prev => ({ ...prev, quotesInput: value }));
                      // Procesar IDs en tiempo real solo para mostrar preview
                      processQuotesInput(value);
                    }}
                    icon={<FaFileInvoiceDollar />}
                    placeholder="689145b3eb54134dedc9814c, 689145b3eb54134dedc9814d"
                    type="text"
                  />
                  
                  {/* Mostrar preview de IDs ingresados (válidos e inválidos) */}
                  {newRegisterForm.quotesInput && (
                    (() => {
                      const inputValue = newRegisterForm.quotesInput;
                      if (!inputValue.trim()) return null;
                      
                      const allIds = inputValue.split(',').map(id => id.trim()).filter(id => id !== '');
                      const validIds = allIds.filter(id => id.length === 24 && /^[a-fA-F0-9]{24}$/.test(id));
                      const invalidIds = allIds.filter(id => !(id.length === 24 && /^[a-fA-F0-9]{24}$/.test(id)));
                      
                      if (allIds.length === 0) return null;
                      
                      return (
                        <div className="mt-2">
                          {invalidIds.length > 0 && (
                            <div className="mb-2">
                              <label className="text-xs text-red-600 mb-1 block">
                                IDs inválidos (deben ser 24 caracteres hexadecimales):
                              </label>
                              <div className="flex flex-wrap gap-2">
                                {invalidIds.map((invalidId, index) => (
                                  <div
                                    key={`invalid-${index}`}
                                    className="inline-flex items-center px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full border border-red-200"
                                  >
                                    <FaTimes className="mr-1" />
                                    {invalidId.length > 20 ? `${invalidId.substring(0, 20)}...` : invalidId}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })()
                  )}
                                    
                  {/* Cotizaciones adicionales (editables) */}
                  {Array.isArray(newRegisterForm.quotes) && newRegisterForm.quotes.length > 0 && (
                    <div>
                      <label className="text-xs text-gray-600 block">
                        Cotizaciones adicionales ({newRegisterForm.quotes.length}):
                      </label>
                      <div className="flex flex-wrap gap-2">
                        {newRegisterForm.quotes.map((quoteId, index) => (
                          <div
                            key={index}
                            className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full border border-blue-200"
                          >
                            <FaFileInvoiceDollar className="mr-1" />
                            ID: {quoteId}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Motivos de la llamada */}
                <div>
                  <label className="flex flex-row items-center text-xs block text-gray-700 mb-1">
                    Motivos de la llamada
                  </label>
                  <div className="flex">
                    <span className="text-xs inline-flex items-center px-3 text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                      <FaQuestionCircle />
                    </span>
                    <FormControl sx={{ flex: 1, minWidth: 0 }}>
                      <Select
                        multiple
                        value={selectedReasons}
                        onChange={handleReasonsChange}
                        input={
                          <OutlinedInput 
                            sx={{ 
                              fontSize: '0.875rem',
                              borderRadius: '0 0.5rem 0.5rem 0',
                              backgroundColor: '#f9fafb',
                              border: '1px solid #d1d5db',
                              color: '#111827',
                              height: '42px',
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                border: '2px solid #3b82f6'
                              },
                              '& .MuiSelect-select': {
                                padding: '0.625rem',
                                fontSize: '0.875rem',
                                color: '#111827'
                              }
                            }}
                          />
                        }
                        renderValue={(selected) => {
                          if (selected.length === callReasons.length) return "Todos los motivos";
                          if (selected.length === 0) return "Seleccionar motivos";
                          return selected.join(', ');
                        }}
                        displayEmpty
                        MenuProps={{
                          disablePortal: false,
                          PaperProps: {
                            style: {
                              maxHeight: 48 * 6.5,
                              width: 250,
                              zIndex: 99999,
                              position: 'fixed'
                            }
                          },
                          anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                          },
                          transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                          },
                          style: {
                            zIndex: 99999
                          }
                        }}
                      >
                        {callReasons.map((reason, index) => {
                          const isSelected = isReasonSelected(reason.value);
                          return (
                            <MenuItem key={index} value={reason.value} sx={{ height: "40px", fontSize: '0.875rem' }}>
                              <Checkbox 
                                checked={isSelected} 
                                sx={{ padding: '4px' }}
                              />
                              <ListItemText 
                                primary={reason.label} 
                                primaryTypographyProps={{ 
                                  fontSize: '0.875rem', 
                                  fontFamily: "Poppins, sans-serif",
                                  color: '#111827'
                                }}
                              />
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/* Servicios relacionados */}
                <div>
                  <label className="flex flex-row items-center text-xs block text-gray-700 mb-1">
                    Servicios relacionados
                  </label>
                  <div className="flex">
                    <span className="text-xs inline-flex items-center px-3 text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                      <FaBoxOpen />
                    </span>
                    <FormControl sx={{ flex: 1, minWidth: 0 }}>
                      <Select
                        multiple
                        value={selectedServiceIds}
                        onChange={handleServicesChange}
                        input={
                          <OutlinedInput 
                            sx={{ 
                              fontSize: '0.875rem',
                              borderRadius: '0 0.5rem 0.5rem 0',
                              backgroundColor: '#f9fafb',
                              border: '1px solid #d1d5db',
                              color: '#111827',
                              height: '42px',
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                border: '2px solid #3b82f6'
                              },
                              '& .MuiSelect-select': {
                                padding: '0.625rem',
                                fontSize: '0.875rem',
                                color: '#111827'
                              }
                            }}
                          />
                        }
                        renderValue={(selected) => {
                          if (selected.length === services.length) return "Todos los servicios";
                          if (selected.length === 0) return "Seleccionar servicios";
                          
                          // Obtener los nombres de servicios basados en los IDs seleccionados
                          const selectedServiceNames = services
                            .filter(service => selected.includes(service.id))
                            .map(service => service.name);
                          
                          return selectedServiceNames.join(', ');
                        }}
                        displayEmpty
                        MenuProps={{
                          disablePortal: false,
                          PaperProps: {
                            style: {
                              maxHeight: 48 * 6.5,
                              width: 250,
                              zIndex: 99999,
                              position: 'fixed'
                            }
                          },
                          anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                          },
                          transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                          },
                          style: {
                            zIndex: 99999
                          }
                        }}
                      >
                        {services.map((service, index) => {
                          const isSelected = isServiceSelected(service.id);
                          return (
                            <MenuItem key={service.id} value={service.id} sx={{ height: "40px", fontSize: '0.875rem' }}>
                              <Checkbox 
                                checked={isSelected} 
                                sx={{ padding: '4px' }}
                              />
                              <ListItemText 
                                primary={service.name} 
                                primaryTypographyProps={{ 
                                  fontSize: '0.875rem', 
                                  fontFamily: "Poppins, sans-serif",
                                  color: '#111827'
                                }}
                              />
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/* Notas de la llamada */}
                <InputFormValue
                  title="Notas"
                  info="Notas de la llamada."
                  value={newRegisterForm.notes}
                  setValue={(value) => setNewRegisterForm(prev => ({ ...prev, notes: value }))}
                  icon={<FaNoteSticky />}
                  placeholder="Notas"
                  type="textarea"
                />

                {/* Sección de audio de la llamada */}
                <div>
                  <label className="flex flex-row items-center text-xs block text-gray-700 mb-1">
                    Audio de la llamada
                  </label>
                  
                  <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
                    {!hasAnyAudio() ? (
                      // Interfaz para elegir entre grabar o subir
                      <div className="space-y-4">
                        {isRecording ? (
                          // Interfaz de grabación activa
                          <div className="flex flex-col items-center space-y-4">
                            <div className="flex items-center space-x-4">
                              <button
                                onClick={stopRecording}
                                className="flex items-center space-x-2 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
                              >
                                <FaStop />
                                <span className="text-xs">Detener grabación</span>
                              </button>
                              <div className="flex items-center space-x-2">
                                <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                                <span className="text-red-600 text-xs font-mono">
                                  Grabando... {formatTime(recordingTime)}
                                </span>
                              </div>
                            </div>
                            
                            <p className="text-xs text-gray-500 text-center">
                              Grabando audio de la llamada...
                            </p>
                          </div>
                        ) : (
                          // Interfaz para elegir opción
                          <div>
                            <div className="text-center">
                              <p className="text-xs text-gray-600 mb-4">
                                Elige una opción para agregar audio a la llamada
                              </p>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              {/* Opción de grabación */}
                              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-blue-400 transition-colors">
                                <div className="flex flex-col items-center space-y-3">
                                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                                    <FaMicrophone className="text-red-600 text-lg" />
                                  </div>
                                  <div className="text-center">
                                    <h3 className="text-sm font-medium text-gray-900">Grabar audio</h3>
                                    <p className="text-xs text-gray-500 mt-1">
                                      Graba el audio directamente desde tu micrófono
                                    </p>
                                  </div>
                                  <button
                                    onClick={startRecording}
                                    disabled={uploadedAudioFile}
                                    className={`flex items-center space-x-2 px-4 py-2 text-white rounded-lg transition-colors text-xs ${
                                      uploadedAudioFile 
                                        ? 'bg-gray-400 cursor-not-allowed' 
                                        : 'bg-red-500 hover:bg-red-600'
                                    }`}
                                  >
                                    <FaMicrophone />
                                    <span>{uploadedAudioFile ? 'Archivo subido' : 'Iniciar grabación'}</span>
                                  </button>
                                </div>
                              </div>
                              
                              {/* Opción de subir archivo */}
                              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-blue-400 transition-colors">
                                <div className="flex flex-col items-center space-y-3">
                                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                                    <FaUpload className="text-blue-600 text-lg" />
                                  </div>
                                  <div className="text-center">
                                    <h3 className="text-sm font-medium text-gray-900">Subir archivo</h3>
                                    <p className="text-xs text-gray-500 mt-1">
                                      Sube un archivo de audio existente
                                    </p>
                                  </div>
                                  <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept="audio/*"
                                    onChange={handleFileUpload}
                                    className="hidden"
                                  />
                                  <button
                                    onClick={() => fileInputRef.current?.click()}
                                    disabled={isRecording}
                                    className={`flex items-center space-x-2 px-4 py-2 text-white rounded-lg transition-colors text-xs ${
                                      isRecording 
                                        ? 'bg-gray-400 cursor-not-allowed' 
                                        : 'bg-blue-500 hover:bg-blue-600'
                                    }`}
                                  >
                                    <FaUpload />
                                    <span>{isRecording ? 'Grabando...' : 'Seleccionar archivo'}</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      // Interfaz de audio (grabado o subido)
                      <div className="space-y-4">
                        {audioBlob ? (
                          // Audio grabado
                          <div>
                            <div className="flex items-center justify-between">
                              <div className="flex items-center space-x-2">
                                <FaMicrophone className="text-green-600" />
                                <span className="text-xs font-medium text-green-800">
                                  Audio grabado ({formatTime(recordingTime)})
                                </span>
                              </div>
                              <div className="flex items-center space-x-2">
                                <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                                  Listo para subir
                                </span>
                              </div>
                            </div>
                            
                            <div className="flex items-center justify-between bg-white p-3 rounded-lg border mt-3">
                              <div className="flex items-center space-x-3">
                                {!isPlaying ? (
                                  <button
                                    onClick={playAudio}
                                    className="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                                  >
                                    <FaPlay className="ml-1" />
                                  </button>
                                ) : (
                                  <button
                                    onClick={pauseAudio}
                                    className="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                                  >
                                    <FaPause />
                                  </button>
                                )}
                                <div className="flex-1">
                                  <div className="text-xs font-medium">Grabación de llamada</div>
                                  <div className="text-xs text-gray-500">
                                    {audioBlob ? formatFileSize(audioBlob.size) : ''}
                                  </div>
                                </div>
                              </div>
                              
                              <button
                                onClick={clearAudio}
                                className="flex items-center space-x-1 px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                              >
                                <FaTrash className="text-xs" />
                                <span className="text-xs">Eliminar</span>
                              </button>
                            </div>
                          </div>
                        ) : (
                          // Archivo subido
                          <div>
                            <div className="flex items-center justify-between">
                              <div className="flex items-center space-x-2">
                                <FaFileAudio className="text-blue-600" />
                                <span className="text-xs font-medium text-blue-800">
                                  Archivo de audio subido
                                </span>
                              </div>
                              <div className="flex items-center space-x-2">
                                <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                                  Listo para subir
                                </span>
                              </div>
                            </div>
                            
                            <div className="flex items-center justify-between bg-white p-3 rounded-lg border mt-3">
                              <div className="flex items-center space-x-3">
                                {!isPlaying ? (
                                  <button
                                    onClick={playAudio}
                                    className="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                                  >
                                    <FaPlay className="ml-1" />
                                  </button>
                                ) : (
                                  <button
                                    onClick={pauseAudio}
                                    className="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                                  >
                                    <FaPause />
                                  </button>
                                )}
                                <div className="flex-1">
                                  <div className="text-xs font-medium">{uploadedAudioFile?.name || 'Archivo de audio'}</div>
                                  <div className="text-xs text-gray-500">
                                    {uploadedAudioFile ? formatFileSize(uploadedAudioFile.size) : ''}
                                  </div>
                                </div>
                              </div>
                              
                              <button
                                onClick={clearUploadedFile}
                                className="flex items-center space-x-1 px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                              >
                                <FaTrash className="text-xs" />
                                <span className="text-xs">Eliminar</span>
                              </button>
                            </div>
                          </div>
                        )}
                        
                        <div className="text-xs text-gray-500 bg-blue-50 p-2 rounded border-l-4 border-blue-400">
                          <strong>Nota:</strong> El audio se subirá automáticamente cuando envíes el formulario.
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Botón de envío - siempre visible */}
          <div className="bg-white mt-4">
            <div className="flex items-center w-full">
              <DinamicButton
                width="100%"
                content="Guardar registro de llamada"
                action={handleSubmit}
                disabled={uploadingStatus}
                icon={uploadingStatus ? <CircularProgress size={14} className="animate-spin" /> : <Upload size={14} />}
              />
            </div>
            {/* Indicador de campos requeridos */}
            <div className="text-xs text-gray-500 text-center mt-2">
              * Los campos Número de llamada, Motivo y Servicios son obligatorios
            </div>
          </div>
        </div>
      </ModalInDrawer>

      <div className="flex flex-row items-center justify-between">        
        <span className="font-semibold leading-none text-sm text-black">Registros de llamadas</span>
        <div className="flex flex-row gap-2">
          <DinamicButton
            width="230px"
            content="Grabar llamada"
            action={() => setManualCallModal(true)}
            icon={<RecordVoiceOver />}
          />          
          <DinamicButton
            width="230px"
            content="Nueva llamada"
            action={() => openWithClientAndQuote(clientData, quoteId)}
            icon={<Call />}
          />
        </div>
      </div>

      {processingCall ? (
        <div className="h-[15rem]">
          <LoadingScreen text="Procesando llamada, espera por favor..." />
        </div>
      ) : (
        calls && calls.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"> 
            {calls.map((r, i) => (
              <CallCard key={i} call={r} services={services} refetch={refetch} />
            ))}
          </div>
        ) : (
          <div className="h-[15rem]">
            <NoDataScreen border text="No hay llamadas registradas" />
          </div>
        )
      )}

    </div>
  );
};

export default CallSection;  


